import React from "react";
import "./Name.css";

function Name(props) {
  const defaultStyles = {
    justifyContent: "center",
    fontSize: "1.5em",
    fontFamily: "Poppins-Medium, sans-serif",
    color: "white",
    textAlign: "center",
    marginTop: "20px",
  };
  const combinedStyles = { ...defaultStyles, ...props.styles };
  return <div style={combinedStyles}>{props.text}</div>;
}
export default Name;
